import { render, staticRenderFns } from "./usd-square.vue?vue&type=template&id=b067b518&"
import script from "./usd-square.vue?vue&type=script&lang=js&"
export * from "./usd-square.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b067b518')) {
      api.createRecord('b067b518', component.options)
    } else {
      api.reload('b067b518', component.options)
    }
    module.hot.accept("./usd-square.vue?vue&type=template&id=b067b518&", function () {
      api.rerender('b067b518', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/usd-square.vue"
export default component.exports